import { ButtonBase, useTheme } from "@mui/material";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import type { FC } from "react";
import { FinancialBalanceRemainderRow } from "web_myplann/Dashboard/Components/FinancialBalanceRemainderRow";
import { FinancialBalanceRow } from "web_myplann/Dashboard/Components/FinancialBalanceRow";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Dashboard.FinancialBalance;

type Props = {
	income: number;
	expense: number;
	balance: number;
	onClick: () => void;
};

export const FinancialBalanceFigures: FC<Props> = ({
	income,
	expense,
	balance,
	onClick,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<ButtonBase
			component="div"
			disableRipple
			onClick={onClick}
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "stretch",
				gap: theme.spacingTokens.md,
				textAlign: "left",
				"&:active": { opacity: theme.pressedOpacity },
			}}
		>
			<FinancialBalanceRow
				icon={ArrowUpRight}
				iconColor={theme.palette.green[500]}
				label={t(R.income)}
				amount={income}
			/>
			<FinancialBalanceRow
				icon={ArrowDownRight}
				iconColor={theme.palette.red[500]}
				label={t(R.expense)}
				amount={expense}
			/>
			<FinancialBalanceRemainderRow balance={balance} />
		</ButtonBase>
	);
};
